module.exports = __webpack_public_path__ + "img/helloMusic.36606e2c.png";